<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Work Management" title="Enquiry List" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-6 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<select class="form-select" v-model="listing_length" @change="fetchJobs()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-2 mt-2">
										<select class="form-select" v-model="product_id" @change="fetchJobs()">
											<option value="">All Products</option>
											<option value="1">Airotrack GPS</option>
											<option value="2">Camera</option>
											<option value="3">Speed Governor</option>
										</select>
									</div>
									<div class="col-md-2 mt-2">
										<select class="form-select" v-model="status" @change="fetchJobs()">
											<option value="">All</option>
											<option value="4">Enquiry</option>
                                            <option value="1">Pending</option>
											<option value="2">Ongoing</option>
                                            <option value="3">Completed</option>
										</select>
									</div>
									<div class="col-md-2 mt-2">
										<input type="text" class="form-control ms-1 float-end" placeholder="Search" v-model="keyword" @keyup="fetchJobs()"/>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>  
                                            <th>Customer</th>
											<th>Location</th>
											<th>Product & Work Type</th>
											<th>Vehicle No</th>
											<th>Conatct</th>
											<th>Date</th>
                                            <th>Status</th>
											<th>Created User</th>
											<th>Options</th>
                                        </tr>
									</thead>
									<tbody v-if="Boolean(jobs.length)">
										<tr align="center" v-for="(job, index) in jobs" :key="index">
                                            <td>{{ (from - 1) + index + 1 }}</td>
											<td>
												{{ job.customer_name }}
											</td>
											<td>{{ job.location }}</td>
											<td>{{ job.product_name }} <br>
											 	<span v-if="job.service_type == 1">New</span>
											  	<span v-else-if="job.service_type == 2">Repair</span>
												<span v-else>Replacement</span>
											</td>
											<td>{{ job.vehicle_no }}</td>
											<td>+91 {{ job.mobile }}</td>
											<td>{{ proxy.$filters.convertDate(job.date) }}</td>
											<td>
												<span class="badge rounded-pill bg-info" v-if="job.status === 1">Pending</span>
												<span class="badge rounded-pill bg-warning" v-else-if="job.status === 2">Follow Up</span>
												<span class="badge rounded-pill bg-success" v-else-if="job.status === 3">Completed</span>
												<span class="badge rounded-pill bg-danger" v-else-if="job.status === 4">Cancelled</span>
											</td>
											<td>{{ job.added_user_name }}</td>
                                            <td>
												<div v-if="job.status != 3">
													<button class="btn btn-warning btn-sm me-1 mb-2" @click="markFollowUp(job.id)">Follow Up</button>
													<router-link :to="{ name: 'update_job', query: { id: job.id, from: 'enquiry_list' } }" class="btn btn-primary btn-sm me-2 mb-2">Edit</router-link><br>
													<button class="btn btn-danger btn-sm me-1 mb-2" @click="markCancel(job.id)">Cancel</button>
												</div>
												<router-link :to="{ name: 'enquiry_details', query: { id: job.id } }" class="btn btn-primary btn-sm me-2 mb-2">Details</router-link>
											</td>
                                        </tr>
                                    </tbody>
									<tbody v-else>
										<tr>
											<td colspan="9" class="text-center">No Enquiries Found</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<div class="row mt-2">
								<div class="col-md-6">
									<p class="text-muted mb-0">
										Showing {{ from || 0 }} to {{ to || 0 }} of {{ total || 0 }} entries
									</p>
								</div>
								<div class="col-md-6">
									<nav aria-label="Page navigation">
										<ul class="pagination justify-content-end">
											<li class="page-item" v-for="(page, index) in pagination" :key="index" :class="[{ disabled: !page.url }, { active: page.active }]">
												<a class="page-link" href="#" @click.prevent="fetchJobs(page.url)" tabindex="-1">
													<span v-if="index === 0">Prev</span>
													<span v-else-if="index === pagination.length - 1">Next</span>
													<span v-else v-html="page.label"></span>
												</a>
											</li>
										</ul>
									</nav>
								</div>
							</div>
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { onMounted, ref, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';
import { routes } from '@/constants/routes';
import { get } from '@/utils/api';
import Swal from '@/utils/swal';

const router = useRouter();
const { proxy } = getCurrentInstance();

const jobs = ref([]);
const listing_length = ref(10);
const status = ref("");
const keyword = ref("");
const from = ref(null);
const to = ref(null);
const total = ref(null);
const pagination = ref({});
const product_id = ref("");

const fetchJobs = (url = null) => {

	const params = {
		limit: listing_length.value,
		keyword: keyword.value,
		product_id: product_id.value,
	}

	const requestUrl = url ?? routes.EnquiryList;

	get(requestUrl, { params }, false)
		.then((response) => {
			if(response.status === 200){
				console.log(response.data.data);
				jobs.value = response.data.data.jobs.data;
				pagination.value = response.data.data.jobs.links;
				from.value = response.data.data.jobs.from;
				to.value = response.data.data.jobs.to;
				total.value = response.data.data.jobs.total;
			} else {
				Swal.fire('', response.data.message || 'Failed to fetch jobs', 'error');
			}
		})
		.catch((error)	=> {
			if (error.response?.status === 422) {
				Swal.fire('', error.response.data.message.limit?.[0] || error.response.data.message.status?.[0] || error.response.data.message.keyword?.[0] || 'Validation error', 'error');
			} else if (error.response?.status === 500) {
				Swal.fire('', error.response.statusText || 'Server error', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		});
};

const markFollowUp = (job_id) => {
	
	Swal.fire({
		icon: 'warning',
		title:"Confirm",
		text:'Are you sure you want to mark follow up for this enquiry?',
		showCancelButton: true,
		confirmButtonText: 'Yes',
		confirmButtonColor: '#e64942',
		cancelButtonText: 'No',
		position: "center",
		showConfirmButton: true,
		timer: '',
		toast: false,
		cancelButtonColor: '#efefef',
		}).then((result)=>{
		if(result.value){
			updateFollowUp(job_id);
		}
		
	});
}

const updateFollowUp = (job_id) => {
	
	const params = {
		job_id: job_id,
	}

	get(routes.EnquiryFollowUp, { params }, false)
		.then((response) => {
			if(response.status === 200){
				Swal.fire('', response.data.message || 'Follow Up updated successfully', 'success');
				fetchJobs();
			} else {
				Swal.fire('', response.data.message || 'Error in updating Follow Up', 'error');
			}
		})
		.catch((error) => {
			if (error.response?.status === 422) {
				Swal.fire('', error.response.data.message.job_id[0] || 'Validation error', 'error');
			} else if (error.response?.status === 500) {
				Swal.fire('', error.response.statusText || 'Server error', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		})
}

const markCancel = (job_id) => {
	
	Swal.fire({
		icon: 'warning',
		title:"Confirm",
		text:'Are you sure you want to cancel this enquiry?',
		showCancelButton: true,
		confirmButtonText: 'Yes',
		confirmButtonColor: '#e64942',
		cancelButtonText: 'No',
		position: "center",
		showConfirmButton: true,
		timer: '',
		toast: false,
		cancelButtonColor: '#efefef',
		}).then((result)=>{
		if(result.value){
			updateCancel(job_id);
		}
		
	});
}

const updateCancel = (job_id) => {
	
	const params = {
		job_id: job_id,
	}

	get(routes.EnquiryCancel, { params }, false)
		.then((response) => {
			if(response.status === 200){
				Swal.fire('', response.data.message || 'Enquiry cancelled successfully', 'success');
				fetchJobs();
			} else {
				Swal.fire('', response.data.message || 'Error in cancelling enquiry', 'error');
			}
		})
		.catch((error) => {
			if (error.response?.status === 422) {
				Swal.fire('', error.response.data.message.job_id[0] || 'Validation error', 'error');
			} else if (error.response?.status === 500) {
				Swal.fire('', error.response.statusText || 'Server error', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		})
}

onMounted(() => {
	fetchJobs();
})

</script>